export default __webpack_public_path__ + "static/media/logo.e81879b1.svg";